<template>
	<bee-numeric-field
	:context="context"
	:action-name="actionName"
	:hide-details="hideDetails"
	:disabled="disabled"
	:label="label"
	:insideTable="insideTable"
	:rules="rules"
	:readonly="readonly"
	@blur="$emit('blur')"
	@keydown-enter-prevent="$emit('keydown-enter-prevent')"
	@keydown-esc-prevent="$emit('keydown-esc-prevent')" 
	@keydown.ctrl.down.native="$emit('keydown-ctrl-down')"
	v-model.number="localValue.amount" 
	:class="type && withColor ? (type == 'debit' ? 'text-red' : 'text-green') : {}"
	:empty-state="emptyState"
	@input="$emit('input', localValue.amount ? localValue : null)"
	:floating-point-precision="floatingPointPrecision"></bee-numeric-field>
</template>
<script>
export default {
name: "bee-money-field",
props: ["value", "type", 'withColor', "label", "insideTable", "rules", "readonly", "emptyState", "disabled", "floatingPointPrecision", "hideDetails", "context", "actionName"],
computed: {
	localValue: {
		get: function() {
			return this.value ? this.value : { amount: null, currency_id: null }
		},
		set: function(value) {
			this.value.amount = value
		}
	}
},
};
</script>
<style>
.text-green input{
  color: green !important;
}
.text-red input{
  color: red !important;
}
</style>
